import { NgZone, Renderer2, Directive, Input } from '@angular/core';

@Directive({
    selector: '[appFocusDirective]'
})
export class FocusDirectiveDirective {
    @Input() cssSelector: string

    constructor(
        private ngZone: NgZone,
        private renderer: Renderer2
    ) { }

    ngAfterViewInit() {
        console.log(this.cssSelector);
        // this.ngZone.runOutsideAngular(() => {
            setTimeout(() => {
                this.renderer.selectRootElement(this.cssSelector).focus();
            }, 0);
        // });
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src3760366518/src/src/app/shared/directive/focus-directive.directive.ts